import { ExportExcelHandle } from "./ExportExcel";
import React from "react";
import PaymentPlanPageNavigationFirstLine from "./PaymentPlanPageNavigationFirstLine";
import PaymentPlanPageNavigationSecondLine from "./PaymentPlanPageNavigationSecondLine";

type Props = {
  refExcelExport: ExportExcelHandle | undefined;
};

const ListPageNavigation = ({ refExcelExport }: Props) => {
  return (
    <>
      <PaymentPlanPageNavigationFirstLine refExcelExport={refExcelExport} />
      <PaymentPlanPageNavigationSecondLine />
    </>
  );
};

export default ListPageNavigation;
